import { render } from "./OvAbortModal.vue?vue&type=template&id=f3120658&scoped=true"
import script from "./OvAbortModal.vue?vue&type=script&lang=js"
export * from "./OvAbortModal.vue?vue&type=script&lang=js"

import "./OvAbortModal.vue?vue&type=style&index=0&id=f3120658&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3120658"],['__file',"src/components/OvAbortModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f3120658"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f3120658', __exports__)) {
    api.reload('f3120658', __exports__)
  }
  
  module.hot.accept("./OvAbortModal.vue?vue&type=template&id=f3120658&scoped=true", () => {
    api.rerender('f3120658', render)
  })

}


export default __exports__